// ABOUTME: Shop page product groups: the "Show parts for" filter and single-item Add to cart.
// ABOUTME: Adds go through Shopify.actions.updateCart, the same cart action the install builder uses.
class AacShopProducts extends HTMLElement {
  #busy = false;
  #onClick = (event) => {
    const filter = event.target.closest('[data-filter]');
    if (filter && this.contains(filter)) return this.#filter(filter);
    const add = event.target.closest('[data-add]');
    if (add && this.contains(add) && add.dataset.add) this.#add(add);
  };

  connectedCallback() { this.addEventListener('click', this.#onClick); }
  disconnectedCallback() { this.removeEventListener('click', this.#onClick); }

  #filter(button) {
    const model = button.dataset.filter;
    this.querySelectorAll('[data-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    this.querySelectorAll('[data-item]').forEach((item) => {
      const fits = item.dataset.fits.split(' ');
      item.hidden = model !== '*' && !fits.includes('*') && !fits.includes(model);

      let variants = {};
      try { variants = JSON.parse(item.dataset.variants || '{}'); } catch { variants = {}; }
      const match = model === '*' ? null : variants[model];
      const detail = item.querySelector('[data-detail]');
      const price = item.querySelector('[data-price]');
      const link = item.querySelector('[data-link]');
      const swap = item.querySelector('[data-swap]');
      if (detail) detail.textContent = match ? match.title : detail.dataset.default;
      if (price) price.textContent = match ? match.price : price.dataset.default;
      if (link && swap) {
        const canAdd = Boolean(match && match.available);
        swap.hidden = !canAdd;
        swap.dataset.add = canAdd ? String(match.id) : '';
        link.hidden = canAdd;
      }
    });
  }

  async #add(button) {
    if (this.#busy) return;
    const error = this.querySelector('[data-error]');
    const updateCart = window.Shopify?.actions?.updateCart;
    if (typeof updateCart !== 'function') {
      if (error) { error.textContent = 'Cart actions are unavailable. Please refresh the page and try again.'; error.hidden = false; }
      return;
    }
    this.#busy = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    const label = button.innerHTML;
    try {
      const response = await updateCart({ lines: [{ merchandiseId: String(button.dataset.add), quantity: 1 }] }, {
        event: { context: 'product', detail: { source: 'aac-shop', sourceId: this.id, itemCount: 1 } },
      });
      if (response?.userErrors?.length) throw new Error(response.userErrors.map((e) => e.message).filter(Boolean).join(' '));
      button.textContent = this.dataset.added;
      setTimeout(() => { button.innerHTML = label; }, 2000);
    } catch (err) {
      console.error('Error adding to cart:', err);
      if (error) { error.textContent = err?.message || 'Unable to add this to your cart. Please try again.'; error.hidden = false; }
    } finally {
      this.#busy = false;
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('aac-shop-products')) customElements.define('aac-shop-products', AacShopProducts);
